__webpack_require__.p =(function() {
    const c = [{ 'host': 'https://dev.cloverstatic.com','envPattern': /^https:\/\/.*.dev.clover.com$/ },{ 'host': 'https://cloverstatic.com','envPattern': /^https:\/\/www(\.eu\.|\.la\.|\.)clover\.com$/ }]; 
    const p = '/web/mfe/cloverDotCom/890801b/';
    for (let i = 0; i < c.length; i++) {
      if (c[i].envPattern.test(window.location.origin)) { return c[i].host + p; }
    }
    return p;
  })();